export enum EmbedMode {
    normal = "normal",
    compact = "compact",
}

export enum EmbedTheme {
    light = "light",
    dark = "dark",
}
